import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Input,
  Tooltip,
  Grid,
} from 'antd';
import {
  QuestionCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { capitalize } from 'utils/normalizers';

const { useBreakpoint } = Grid;

const InputSearch = React.forwardRef((_props, ref) => {
  const {
    onPressEnter,
    tittle,
    control,
    disabled,
    loading,
    ...props
  } = _props;
  const screen = useBreakpoint();
  return (
    <Form.Item>
      <Input.Group style={{ display: 'flex' }} compact className="search-component">
        <Form.Item
          normalize={capitalize}
          name="q"
          label={(
            <span>
              Buscar
              {' '}
              {!screen.xs && 'Ciudadano'}
              {' '}
              {tittle && (
                <Tooltip
                  title={tittle}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              )}
            </span>
          )}
          style={{ width: 'calc(100% - 64px)', marginBottom: 0 }}
        >
          <Input
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            ref={ref}
            className="input-busqueda-caja"
            disabled={disabled}
            allowClear
            autoComplete="off"
            onPressEnter={!loading ? onPressEnter : null}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            onClick={() => (!loading ? onPressEnter() : null)}
            className="primary-on-hover"
            disabled={disabled}
            style={{
              height: !screen.xs && 64,
              width: !screen.xs && 64,
              marginTop: 23,
            }}
          >
            <SearchOutlined />
          </Button>
        </Form.Item>
        <Form.Item className="primary-on-hover" label=" " style={{ marginBottom: 0 }}>
          {control}
        </Form.Item>
      </Input.Group>
    </Form.Item>
  );
});

InputSearch.propTypes = {
  onPressEnter: PropTypes.func.isRequired,
  tittle: PropTypes.string,
  control: PropTypes.node,
  disabled: PropTypes.bool,
};

InputSearch.defaultProps = {
  tittle: '',
  control: (<span />),
  disabled: false,
};

export default InputSearch;
